import { ApiFilterOperator } from '@fluentsms/graphql';

export enum DocumentTableAttributes {
  ORG_IDs = 'attributes.orgIds',
  STATES = 'attributes.states',
  UNDERWRITERS = 'attributes.underwriters',
  CREATED_BY = 'createdBy',
  DOCUMENT_ID = 'documentId',
  DOCUMENT_TYPE = 'documentType',
  FILE_TYPE = 'fileType',
  IS_DELETED = 'isDeleted',
  IS_VISIBLE = 'isVisible',
  NAME = 'name',
  ORDER_ID = 'orderId',
  SIZE_BYTES = 'sizeBytes',
  UPDATED_BY = 'updatedBy',
  UPDATED_BY_NAME = 'updatedByName',
  CREATED_TIME_STAMP = 'createdTimestamp',
  UPDATED_TIMESTAMP = 'updatedTimestamp',
  UPLOAD_STATUS = 'uploadStatus',
  TENANT_ID = 'tenantId',
  DESCRIPTION = 'description',
  COMPANY_ID = 'companyId',
}

/**
 * Maps datagrid filter operator to API filter operator.
 *
 * For example, `is` operator in datagrid is mapped to `eq` operator in API
 */
export enum OperatorMap {
  'is' = ApiFilterOperator.Eq,
  'includes' = ApiFilterOperator.Contains,
  'excludes' = ApiFilterOperator.NotContains,
  'isNot' = ApiFilterOperator.Neq,
  'isNotEmpty' = ApiFilterOperator.Neq,
  'isAfter' = ApiFilterOperator.Gt,
  'isGreaterThan' = ApiFilterOperator.Gte,
  'isLessThan' = ApiFilterOperator.Lte,
  'contains' = ApiFilterOperator.Contains,
  'startsWith' = ApiFilterOperator.Begins,
  'notContains' = ApiFilterOperator.NotContains,
  'isBefore' = ApiFilterOperator.Lt,
  'all' = ApiFilterOperator.Size,
}

export type TemplateFilterAttribute = {
  field: keyof typeof DocumentTableAttributes;
};

/**
 * Filter object `value` produced by Datagrid
 *
 */
export type TableFilterValue = {
  columnId: keyof typeof DocumentTableAttributes;
  operator: string;
  value: string;
};

/**
 * Filter object produced by Datagrid
 *
 */
export type TableFilter = {
  id: string;
  value: TableFilterValue[];
};

//custom types based on the Filters on DataGrid
export type FilterType =
  | 'dataGridEnumTypeFilter'
  | 'dataGridStringFilter'
  | 'dataGridMultichipFilter'
  | 'dataGridModFilter';
export interface FilterColumns {
  id: string;
  Header: string;
  accessor: string;
  filterType: FilterType;
  isEnumFilterColumn?: boolean;
  enumFilterOptions?: string[];
  width?: number;
  isMultiselectColumn?: boolean;
  enableSelectAll?: boolean;
  multiselectFilterOptions?: string[];
  hideAllOperatorOption?: boolean;
}
